<template lang="pug">
div.g-text-field(:class="{ 'g-text-field--is-disabled': disabled}")
  h8.g-text-field__label {{label}}
  v-text-field.white(
    v-bind="{ ...$attrs, type, success, error, color, disabled }",
    :value="value",
    outlined,
    :append-icon="theAppendIcon",
    :class="{ 'colored--input': !success && !error, 'icon--text': !color }",
    v-on="$listeners",
    :data-cy="dataCy"
  )
</template>

<script>
export default {
  name: 'GInput',
  props: {
    value: {},
    label: {
      type: String,
    },
    type: {
      type: String,
      default: 'text',
    },
    success: {
      type: Boolean,
      default: false,
    },
    error: {
      type: Boolean,
      default: false,
    },
    appendIcon: {
      type: String,
    },
    color: {
      type: String,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    dataCy: {
      type: String,
      default: null,
    },
  },
  data: () => ({}),
  computed: {
    theAppendIcon() {
      if (this.appendIcon) return this.appendIcon;
      if (this.success) return 'mdi-check';
      if (this.error) return 'mdi-close';
      return null;
    },
  },
};
</script>

<style lang="scss">
@import "TextField.scss";
</style>
